import React from 'react'
import { TableHeader } from '../../commons'
import { ALL_CLIENT_MEET_UP_STATUS } from '../../../constant/tableHeadersConstants/LeadDirectoryConstants/leadDirectoryListTableHeaders'
import AllClientMeetUpStatusTableData from './AllClientMeetUpStatusTableData'

type AppProps={
    data:any;
    handleEditMeetUp:(id:number)=>void;
}

const AllClientMeetUpStatusTable = ({data,handleEditMeetUp}:AppProps) => {
  return (
    <div className="new-table-style">
      <table className="table table-bordered thead-light">
                <thead className='text-start'>
                    <TableHeader
                        tableHeader={ALL_CLIENT_MEET_UP_STATUS} 
                    />
                </thead>
                <tbody>
                    <AllClientMeetUpStatusTableData
                    data={data}
                    handleEditMeetUp={handleEditMeetUp}
                    tableHeader={ALL_CLIENT_MEET_UP_STATUS}
                    />
                </tbody>
            </table>
    </div>
  )
}

export default AllClientMeetUpStatusTable
